import React, { Component } from 'react';

import { TableLayout } from '../Menu/Stock/containers/Layout';
import SearchBar from './Layouts/SeachBar';
import PaygoNewSms from '../Menu/module/PaygoNewSms';
import Dialog from '../../commonModules/interface/Dialog';
import { isEmpty } from 'lodash';
import { Table, TableHead, TableBody, TableCell, TableRow, Grid, Button, Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import PageAdmin from './Layouts/PageAdmin';
import { lightBlue, orange } from '@material-ui/core/colors';
import { GroupRounded, MessageRounded, Payment } from '@material-ui/icons';
import SearchBarAction from './Layouts/SearchBarAction';
import CardButton from '../../commonModules/interface/CardButton';
import { toast } from 'react-toastify';

class SmsList extends Component {
    state = { 
        new: false,
        group: false,
        creditAccount: false,
        list: [],
        amount: "",
        priceList:[
            {nbSms: 0, price: 0},
            
        ],
        smsChoice:"",
        currency:"",
        country:"",
        errSmsForm: "",
        openFormTypes: false,
    }
    componentDidMount = async  () => {
        const { SMS } = this.props;
        if( !SMS ){
            await this.props.fetchSms()
        }
        this.filterList()
        Promise.all([
            this.props.getProspectList(),
            this.props.getStoreClients(),
            this.fetchPriceList(),
            this.props.fetchCredit && this.props.fetchCredit(),
        ])

    }
    filterList = (list) => {
        if( !list ){
            if(!isEmpty(this.props.SMS) ){
                list = Object.keys(this.props.SMS)
            } else {
                list = []
            }
        }
        this.setState({
            list
        })
    }
    fetchPriceList = async () => {
        try{
            const res = await fetch('/message/get/price/list',{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            });
            let infos = await res.json();
            console.log({infos});

            if(infos.error){ 
                console.log("[ERROR] get SMS PRICE LIST ", infos.error);
            } else {
                this.setState({
                    priceList: infos.prices.priceList || [],
                    country: infos.prices.country,
                    currency: infos.prices.currency
                })
            }
        } catch(err){
            console.log("[ERROR] get SMS PRICE LIST ", err);
        }

    }
    validSmsPack = () => {
        const { smsChoice } = this.state;
        if(smsChoice.nbSms && smsChoice.nbSms){
            this.setState({
                errSmsForm: ""
            })
            return true
        }
        this.setState({
            errSmsForm: "Veuillez choisir un Pack SMS"
        })
        return false
    }
    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }
    handleSubmitPayment = async () => {
        const { smsChoice } = this.state;
        if(this.validSmsPack){
            let data = {
                // accountID : back
                amount : smsChoice.price,
                nbSms : smsChoice.nbSms,
                // currency: ?
            }
            try {
                const res = await fetch("/message/payment/new", {
                    method:'POST',
                    headers: { 
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                    },
                    body:JSON.stringify({data}),
                    credentials: 'same-origin',
                });
                let infos = await res.json();
                console.log({infos});
    
                if(infos.error){ 
                    console.log("[ERROR] submit sms payment ", infos.error);
                    toast.error(  "Erreur ")
                } else {
                    toast.success( "Paiement validé")
                    this.setState({
                        creditAccount: false,
                    })
                }
            } catch(err){
                console.log("[ERROR] submit sms payment ", err);
                toast.error(  "Erreur Technique")
            }
        }
    }
    
    render() {
        const { SMS } = this.props;
        const { priceList, creditAccount, group} = this.state;
        console.log('====================================');
        console.log("[STATE] ", this.state);
        console.log('====================================');
        console.table(priceList)

        let actions = [
            {
                openAction:() => this.setState({ new: true }),
                icon:<MessageRounded color="primary"/>,
                title: "Nouveau Message"
            },
            {
                openAction: () =>this.setState({ new: true, group: true }),
                icon: <GroupRounded color="secondary" />,
                title: "Nouveau Groupe"
            },
            {
                openAction: () =>this.setState({ creditAccount: true }),
                icon: <Payment style={{ color: lightBlue[200] }} />,
                title: "Acheter des Sms"
            },
        ]

        return (
            <PageAdmin title="SMS">
                {this.state.new &&
                    <PaygoNewSms 
                        close={()=> this.setState({ new: false, group: false })} 
                        group={ group } 
                    />
                }
                { creditAccount &&
                    <Dialog
                        block={ creditAccount }
                        title={`Choisissez un Pack SMS pour ${this.state.country}`}
                        close={()=> this.setState({ creditAccount: false })}
                        submitAction={this.handleSubmitPayment}
                    >
                        <Table className="table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Nombre SMS</TableCell>
                                    <TableCell>Prix Unitaire</TableCell>
                                    {/* <TableCell>Remise</TableCell> */}
                                    <TableCell>Total</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {!isEmpty( priceList ) && 
                                priceList.map( item => (
                                    <TableRow>
                                        <TableCell>{item.nbSms}</TableCell>
                                        <TableCell>{item.price / item.nbSms} {this.state.currency}</TableCell>
                                        <TableCell>{item.price} {this.state.currency}</TableCell>
                                        <TableCell onClick={() => this.setState({smsChoice: item})} >
                                            <div className="radio m-0">
                                                <label>
                                                    <input type="radio" name="smsChoice" value="" />
                                                    <i className="input-helper"></i>
                                                </label>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))
                            }
                            </TableBody>
                        </Table>
                        {this.state.errSmsForm &&
                            <Alert severity="error">
                                {this.state.errSmsForm}
                            </Alert>
                        }
                        {/* <Button className="btn btn-success" onClick={this.handleSubmitPayment}>Valider</Button> */}

                </Dialog>
                }
                {this.state.openFormTypes &&
                    <Dialog
                        title="Nouveau"
                        block={true}
                        close={() => this.setState({ 
                            openFormTypes: false,
                        }) }
                    >
                        {actions.map(action =>
                            <CardButton
                                action={action.openAction}
                                icon={action.icon}
                                title={action.title}
                            />
                        )}
                    </Dialog>
                }   
                {/* <Grid container spacing={2} className="text-center">
                    <Grid item xs={12} sm={4}>
                        <Button 
                            variant="contained" 
                            onClick={()=>
                                this.setState({ new: true })
                            }>Nouveau Message</Button>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Button 
                            variant="contained" 
                            onClick={()=> this.setState({ new: true, group: true })
                            }>Nouveau Groupe</Button>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Button 
                            variant="contained" 
                            onClick={()=> this.setState({ creditAccount: true })
                            }>Acheter des Sms</Button>
                    </Grid>
                </Grid> */}

                <Box display="flex" justifyContent="flex-end" alignItems="center" px={1} pt={1}>
                    <Box style={{ fontSize: 13 }} title="Solde SMS facturé sur le compte MyJouleBox de cet admin (consommé à chaque envoi).">
                        <strong>Compte MyJouleBox:</strong>{' '}
                        <span style={{ color: (this.props.CREDIT && this.props.CREDIT.creditSMS > 0) ? '#1976d2' : '#d32f2f' }}>
                            {(this.props.CREDIT && this.props.CREDIT.creditSMS != null) ? this.props.CREDIT.creditSMS : '—'} SMS
                        </span>
                    </Box>
                </Box>

                <SearchBarAction list={ SMS } filterList={this.filterList} action={ () => this.setState({ openFormTypes: true}) } />
                                  
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Destinataire</TableCell>
                            <TableCell>Statut</TableCell>
                            <TableCell>Message</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {SMS && this.state.list.map( ID => {
                            let sms = SMS[ID]
                            return(
                                <TableRow key={sms.timeSent}>
                                    <TableCell>{ new Date(sms.timeSent).toLocaleString('fr-FR') }</TableCell>
                                    <TableCell>{ sms.receivers.join(' - ') }</TableCell>
                                    <TableCell>{ sms.status }</TableCell>
                                    <TableCell>{ sms.content }</TableCell>
                                </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </TableLayout>
            </PageAdmin>
        );
    }
}


export default SmsList